export class User {
  id: number;
  username: string;
  password: string;
  userRole: string;
  reference: string;
  name: string;
  accessToken: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/user.ts